export {default} from './CollectWalletsSettings';
